import { FC, Fragment } from 'react';
import { Switch } from 'react-router-dom';
import { PrivateRoute } from '../router/components';
import RouteConstants from '../router/RouteConstants';
import { MarketIntelligence } from './MarketIntelligence';

export const MarketIntelligenceRouter: FC = () => (
  <Fragment>
    <Switch>
      <PrivateRoute path={RouteConstants.marketIntellingence} component={MarketIntelligence} />
    </Switch>
  </Fragment>
);
